import React from "react";
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

export const BentoGrid = ({
  className,
  children,
}: {
  className?: string;
  children?: React.ReactNode;
}) => {
  return (
    <div
      className={cn(
        "grid grid-cols-1 md:grid-cols-6 gap-6 max-w-7xl mx-auto px-4",
        className
      )}
    >
      {children}
    </div>
  );
};

export const BentoGridItem = ({
  className,
  title,
  description,
  header,
  icon,
}: {
  className?: string;
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  header?: React.ReactNode;
  icon?: React.ReactNode;
}) => {
  return (
    <motion.div
      whileHover={{ y: -5 }}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className={cn(
        "rounded-3xl group relative overflow-hidden bg-obsidian-100 border-beam flex flex-col justify-between h-full min-h-[400px]",
        className
      )}
    >
      <div className="absolute inset-0 z-0">
        {header}
        <div className="absolute inset-0 bg-linear-to-t from-obsidian via-obsidian/40 to-transparent opacity-80" />
      </div>
      
      <div className="relative z-10 p-8 mt-auto group-hover:translate-y--2 transition-transform duration-300">
        <div className="flex items-center gap-2 mb-4">
           <div className="p-2 rounded-full bg-white/10 backdrop-blur-md">
             {icon}
           </div>
        </div>
        
        <h3 className="font-display font-bold text-2xl text-white mb-2">
          {title}
        </h3>
        <p className="font-sans font-normal text-gray-400 text-sm max-w-xs leading-relaxed">
          {description}
        </p>
      </div>
    </motion.div>
  );
};
